import { render, staticRenderFns } from "./NewSystemSettings.vue?vue&type=template&id=2a62835a&scoped=true"
import script from "./NewSystemSettings.vue?vue&type=script&lang=js"
export * from "./NewSystemSettings.vue?vue&type=script&lang=js"
import style0 from "./NewSystemSettings.vue?vue&type=style&index=0&id=2a62835a&prod&scoped=true&lang=scss"
import style1 from "./NewSystemSettings.vue?vue&type=style&index=1&id=2a62835a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a62835a",
  null
  
)

export default component.exports